import { Wand2 } from "lucide-react";
import { Button } from "@/components/ui/Button";

export type AllotmentRoom = { id: string; name: string; roomNumber?: string | number | null };

const roomLabel = (room: AllotmentRoom) => `${room.name}${room.roomNumber ? ` - Room ${room.roomNumber}` : ""}`;

// Allots the rooms a booking needs. A booking for N rooms can only be confirmed once exactly N are picked;
// "Auto select" fills the first N free rooms of the requested type in one click.
export function RoomAllotmentPicker({ roomsNeeded, options, selected, loading, onChange }: {
  roomsNeeded: number;
  options: AllotmentRoom[];
  selected: string[];
  loading: boolean;
  onChange: (roomIds: string[]) => void;
}) {
  const enough = options.length >= roomsNeeded;
  const toggle = (roomId: string) =>
    onChange(selected.includes(roomId) ? selected.filter((id) => id !== roomId) : selected.length < roomsNeeded ? [...selected, roomId] : selected);

  return (
    <div className="room-allotment">
      <div className="room-allotment__head">
        <strong>Rooms allotted: {selected.length} / {roomsNeeded}</strong>
        <Button type="button" variant="secondary" disabled={loading || !options.length} onClick={() => onChange(options.slice(0, roomsNeeded).map((room) => room.id))}>
          <Wand2 size={15} /> Auto select
        </Button>
      </div>
      {roomsNeeded === 1 ? (
        <select value={selected[0] ?? ""} onChange={(event) => onChange(event.target.value ? [event.target.value] : [])}>
          <option value="">Select a room</option>
          {options.map((room) => <option key={room.id} value={room.id}>{roomLabel(room)}</option>)}
        </select>
      ) : (
        <div className="room-allotment__list">
          {options.map((room) => (
            <label className="check-option" key={room.id}>
              <input type="checkbox" checked={selected.includes(room.id)} disabled={!selected.includes(room.id) && selected.length >= roomsNeeded} onChange={() => toggle(room.id)} />
              <span>{roomLabel(room)}</span>
            </label>
          ))}
        </div>
      )}
      {!loading && !enough && (
        <small className="field-error">Only {options.length} of the {roomsNeeded} rooms needed are available for these dates, so this booking can't be confirmed.</small>
      )}
    </div>
  );
}
